import authApi from "interceptor/authInterceptor";
import { get } from "lodash";
import { dispatch } from "store";
import { onBoardingStatusUpdate, onboardedCompanyDetails } from "./auth";
import { updateSelectedCompany } from "./dashboardSearch";
import { createSlice } from "@reduxjs/toolkit";

const localStorageWebhookKeys = [
  "webhookActiveStep",
  "webhookPayrollSystem",
  "webhookFormData",
  "onboardPayrollSystem",
];

const initialState = {
  webhookFormData: null,
  webhookActiveStep: 0,
  webhookPayrollSystem: "",
  isLoading: false,
};

const webhookOnboard = createSlice({
  name: "webhookOnboard",
  initialState,
  reducers: {
    getWebhookFormData: (state) => {
      const data = JSON.parse(
        localStorage.getItem("webhookFormData") || "null"
      );
      state.webhookFormData = data || initialState.webhookFormData;
    },
    setWebhookFormData: (state, action) => {
      state.webhookFormData = action.payload || initialState.webhookFormData;
      localStorage.setItem(
        "webhookFormData",
        JSON.stringify(state.webhookFormData)
      );
    },
    getWebhookActiveStep: (state) => {
      const activeStep = JSON.parse(
        localStorage.getItem("webhookActiveStep") || "0"
      );
      state.webhookActiveStep = activeStep || initialState.webhookActiveStep;
    },
    setWebhookActiveStep: (state, action) => {
      state.webhookActiveStep =
        action.payload || initialState.webhookActiveStep;
      localStorage.setItem(
        "webhookActiveStep",
        JSON.stringify(state.webhookActiveStep)
      );
    },
    getWebhookPayrollSystem: (state) => {
      const payrollSystem = localStorage.getItem("webhookPayrollSystem") || "";
      state.webhookPayrollSystem =
        payrollSystem || initialState.webhookPayrollSystem;
    },
    setWebhookPayrollSystem: (state, action) => {
      state.webhookPayrollSystem =
        action.payload || initialState.webhookActiveStep;
      localStorage.setItem("webhookPayrollSystem", state.webhookPayrollSystem);
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    clearemployerListData: () => initialState,
  },
});

export const {
  getWebhookFormData,
  setWebhookFormData,
  getWebhookActiveStep,
  setWebhookActiveStep,
  getWebhookPayrollSystem,
  setWebhookPayrollSystem,
  setIsLoading,
  clearemployerListData,
} = webhookOnboard.actions;
export default webhookOnboard.reducer;

export function setWebhookCompanyInfo(payload: any) {
  return async () => {
    const response = await authApi.post(`/v2/api/webhook/company`, payload);
    const companyData = response?.data?.data?.company;

    dispatch(onBoardingStatusUpdate({ onBoardedCompanyData: companyData }));

    const onBoardedUserCompanyDetails = {
      company_name: get(companyData, "company_name", ""),
      _id: get(companyData, "_id", ""),
    };

    dispatch(
      onboardedCompanyDetails({
        onBoardedCompanyDetails: onBoardedUserCompanyDetails,
      })
    );

    dispatch(
      updateSelectedCompany({ selectedCompany: onBoardedUserCompanyDetails })
    );

    localStorageWebhookKeys.forEach((key) => localStorage.removeItem(key));
  };
}
